export default {"src":"/_next/static/media/recent-games.92ac10ad.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};